exports.components = {
  "component---src-pages-[slug]-js": () => import("./../../../src/pages/[slug].js" /* webpackChunkName: "component---src-pages-[slug]-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

